(function() {
  'use strict';

  function initCarousel(carousel) {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const slides = Array.from(carousel.querySelectorAll('.hero-product-carousel__slide'));
    if (slides.length === 0) return;

    let currentIndex = 0;
    let autoplayInterval = null;
    
    // Get settings from data attributes
    const autoplayEnabled = carousel.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(carousel.dataset.autoplayInterval || '5') * 1000;

    // Show specific slide with crossfade animation
    function showSlide(index) {
      // Get all non-filtered slides
      const visibleSlides = slides.filter(slide => !slide.classList.contains('filtered'));
      
      if (visibleSlides.length === 0) return;

      if (index < 0) {
        index = visibleSlides.length - 1;
      } else if (index >= visibleSlides.length) {
        index = 0;
      }

      const targetSlide = visibleSlides[index];
      const actualIndex = slides.indexOf(targetSlide);

      // Get the currently selected filter value from the active slide
      const sectionId = carousel.getAttribute('data-section-id');
      const activeSlide = slides.find(slide => slide.classList.contains('active') && !slide.classList.contains('filtered'));
      let selectedFilterValue = 'all';
      if (activeSlide) {
        const activeRadio = activeSlide.querySelector(`input[name="product-filter-${sectionId}"]:checked`);
        if (activeRadio) {
          selectedFilterValue = activeRadio.value;
        }
      }

      // Start crossfade: fade out current slide, fade in new slide
      slides.forEach((slide, i) => {
        if (i === actualIndex && !slide.classList.contains('filtered')) {
          // Fade in new slide
          slide.classList.add('active');
          slide.setAttribute('aria-hidden', 'false');
          
          // Sync the radio button selection to match the previous selection
          const radio = slide.querySelector(`input[name="product-filter-${sectionId}"][value="${selectedFilterValue}"]`);
          if (radio) {
            radio.checked = true;
          }
          
          // Force reflow to ensure transition starts
          slide.offsetHeight;
        } else {
          // Fade out current slide
          slide.classList.remove('active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      currentIndex = index;
    }

    // Navigation functions
    function nextSlide() {
      stopAutoplay();
      showSlide(currentIndex + 1);
      if (autoplayEnabled && slides.length > 1) {
        startAutoplay();
      }
    }

    function prevSlide() {
      stopAutoplay();
      showSlide(currentIndex - 1);
      if (autoplayEnabled && slides.length > 1) {
        startAutoplay();
      }
    }

    // Autoplay functions
    function startAutoplay() {
      stopAutoplay();
      if (autoplayEnabled && slides.length > 1) {
        autoplayInterval = setInterval(() => {
          nextSlide();
        }, autoplayDelay);
      }
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Setup navigation buttons using event delegation
    // This ensures buttons work even when slides change
    carousel.addEventListener('click', function(e) {
      const target = e.target.closest('[data-nav]');
      if (!target) return;
      
      if (target.getAttribute('data-nav') === 'prev') {
        e.preventDefault();
        e.stopPropagation();
        prevSlide();
      } else if (target.getAttribute('data-nav') === 'next') {
        e.preventDefault();
        e.stopPropagation();
        nextSlide();
      }
    });

    // Setup keyboard navigation
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
      }
    });

    // Pause autoplay on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', () => {
      if (autoplayEnabled && slides.length > 1) {
        startAutoplay();
      }
    });

    // Setup product filtering tabs
    function setupFiltering() {
      const sectionId = carousel.getAttribute('data-section-id');
      const filterInputs = carousel.querySelectorAll(`input[name="product-filter-${sectionId}"]`);
      if (filterInputs.length === 0) return;

      filterInputs.forEach(input => {
        input.addEventListener('change', function() {
          const filterValue = this.value;
          filterProducts(filterValue);
        });
      });
    }

    function filterProducts(filterValue) {
      const allSlides = Array.from(carousel.querySelectorAll('.hero-product-carousel__slide'));
      let firstVisibleIndex = -1;

      allSlides.forEach((slide, index) => {
        const productTitle = slide.getAttribute('data-product-title') || '';
        
        if (filterValue === 'all') {
          slide.classList.remove('filtered');
          if (firstVisibleIndex === -1) firstVisibleIndex = index;
        } else if (productTitle.includes(filterValue)) {
          slide.classList.remove('filtered');
          if (firstVisibleIndex === -1) firstVisibleIndex = index;
        } else {
          slide.classList.add('filtered');
          slide.classList.remove('active');
        }
      });

      // Show first visible slide
      if (firstVisibleIndex >= 0) {
        const visibleSlides = allSlides.filter(slide => !slide.classList.contains('filtered'));
        const visibleIndex = visibleSlides.indexOf(allSlides[firstVisibleIndex]);
        if (visibleIndex >= 0) {
          currentIndex = visibleIndex;
          showSlide(visibleIndex);
        }
      }
    }

    // Initialize first slide
    showSlide(0);

    // Start autoplay if enabled
    if (autoplayEnabled && slides.length > 1) {
      startAutoplay();
    }

    // Setup product filtering tabs
    setupFiltering();

    // Setup touch/swipe handling for mobile
    function setupTouchHandling() {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      let isDragging = false;
      const minSwipeDistance = 30; // Minimum distance in pixels to trigger swipe (reduced for better responsiveness)

      carousel.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isDragging = false;
      }, { passive: true });

      carousel.addEventListener('touchmove', function(e) {
        if (!touchStartX || !touchStartY || e.touches.length !== 1) return;
        
        touchEndX = e.touches[0].clientX;
        touchEndY = e.touches[0].clientY;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        
        // Check if horizontal movement is greater than vertical (swipe, not scroll)
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
          isDragging = true;
          // Prevent default scrolling while swiping horizontally
          e.preventDefault();
        }
      }, { passive: false });

      carousel.addEventListener('touchend', function(e) {
        if (!touchStartX || !touchStartY) {
          touchStartX = 0;
          touchStartY = 0;
          touchEndX = 0;
          touchEndY = 0;
          isDragging = false;
          return;
        }

        if (!e.changedTouches || !e.changedTouches[0]) {
          touchStartX = 0;
          touchStartY = 0;
          touchEndX = 0;
          touchEndY = 0;
          isDragging = false;
          return;
        }

        touchEndX = e.changedTouches[0].clientX;
        touchEndY = e.changedTouches[0].clientY;

        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        const absDeltaX = Math.abs(deltaX);
        const absDeltaY = Math.abs(deltaY);

        // Only trigger swipe if horizontal movement is greater than vertical
        // and exceeds minimum swipe distance
        if (absDeltaX > absDeltaY && absDeltaX > minSwipeDistance) {
          e.preventDefault();
          e.stopPropagation();
          if (deltaX > 0) {
            // Swipe right - go to previous slide (same as clicking prev button)
            prevSlide();
          } else {
            // Swipe left - go to next slide (same as clicking next button)
            nextSlide();
          }
        }

        // Reset touch values
        touchStartX = 0;
        touchStartY = 0;
        touchEndX = 0;
        touchEndY = 0;
        isDragging = false;
      }, { passive: false });
    }

    setupTouchHandling();
  }

  // Initialize all carousels on page load
  function initAllCarousels() {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(initCarousel);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Handle theme editor section loads
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('[data-carousel]');
      if (carousel) {
        initCarousel(carousel);
      }
    });
  }
})();

